import React from "react";
import { Helmet } from "react-helmet";
import DashboardLayout from "@/components/DashboardLayout";
import SolutionsHero from "@/components/solutions/SolutionsHero";
import DeepResearchAgents from "@/components/solutions/DeepResearchAgents";
import CodingAgents from "@/components/solutions/CodingAgents";
import CustomerSupportAgents from "@/components/solutions/CustomerSupportAgents";
import VoiceTechnology from "@/components/solutions/VoiceTechnology";
import OtherSolutions from "@/components/solutions/OtherSolutions";
import PageCallToAction from "@/components/PageCallToAction";

const Solutions = () => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>AI Solutions | OpenPipe</title>
        <meta
          name="description"
          content="Explore our AI solutions tailored to your business needs."
        />
      </Helmet>
      <div className="max-w-6xl mx-auto space-y-10">
        <div className="space-y-3">
          <h1 className="text-4xl font-bold tracking-tight bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
            Solutions
          </h1>
          <p className="text-muted-foreground text-lg max-w-2xl">
            Explore our AI solutions tailored to your business needs.
          </p>
        </div>
        <div className="grid gap-10">
          <DeepResearchAgents />
          <CodingAgents />
          <CustomerSupportAgents />
          <VoiceTechnology />
          <OtherSolutions />
        </div>
        <PageCallToAction />
      </div>
    </DashboardLayout>
  );
};

export default Solutions;
